import React, { Component } from 'react';
import { hot } from 'react-hot-loader';

import { HashRouter, Route, Switch } from 'react-router-dom';

import classNames from 'classnames/bind';

import Footer from './components/Footer';

import IndexPage from './pages/IndexPage';
import ArchitecturePage from './pages/ArchitecturePage';
import GeniousPage from './pages/GeniousPage';
import MatchpointPage from './pages/MatchpointPage';
import PlacePage from './pages/PlacePage';

import style from './App.scss';

const ctx = classNames.bind(style);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <HashRouter>
        <div className={ctx('app')}>
          <Switch>
            <Route exact path="/" component={IndexPage} />
            <Route path="/architecture" component={ArchitecturePage} />
            <Route path="/genious" component={GeniousPage} />
            <Route path="/main" component={IndexPage} />
            <Route path="/matchpoint" component={MatchpointPage} />
            <Route path="/place" component={PlacePage} />
          </Switch>
          <Footer />
        </div>
      </HashRouter>
    );
  }
}

export default hot(module)(App);

// https://tylermcginnis.com/react-router-cannot-get-url-refresh/
//<Route exact path="/" component={IndexPage} /> MatchpointPage PlacePage
